import { createRoot } from 'react-dom/client'
import { App } from './App'
import './styles.css'

const container = document.getElementById('root')
if (!container) throw new Error('Wurzelelement #root fehlt in index.html')

// Bewusst ohne StrictMode: der doppelte Aufbau im Entwicklungsmodus wuerde die
// Scroll-Bahn zweimal anlegen und vermessen. Das ist bei einer Messung, die an
// echten Scroll-Events haengt, mehr Stolperfalle als Hilfe.
createRoot(container).render(<App />)

// Service Worker nur im Produktionsbetrieb: im Entwicklungsmodus wuerde er
// Aenderungen aus dem Cache ueberdecken.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js')
  })
}
